import { useState, useEffect, React } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Toaster, toast } from "react-hot-toast";
import { MobileView, isMobile } from "react-device-detect";
import BrowserView from "./components/BrowserView";
import {
  changePage,
  pageState,
  pageLoaded,
  toggleThumbnailDrawer,
} from "./actions/navigationActions";
import AdobeFullScreen from "./components/AdobeFullScreen";
import Drawer from "./Drawer/Drawer";
import KeyNotePage from "./components/KeyNotePage";
import HoverActivator from "./components/HoverActivator";
import HoverDrawerPopout from "./components/HoverDrawerPopout";
import CenterSpinner from "./components/CenterSpinner";
import "./App.css";
import "./Drawer.css";

function App() {
  const [registered, setRegistered] = useState(false);
  const { loadedPages, currentPage, location } = useSelector((state) => ({
    ...state.navigationReducer,
  }));
  const dispatch = useDispatch();

  // console.log("Page states", pageStates);
  const extractPage = (url) => {
    const pattern = /react:\/\/([\d|\w]+)\/?(\S*)\??(\S*)/;
    const match = pattern.exec(url);
    return match || ["url", url];
  };

  const navigate = (e) => {
    const [url, page, param] = extractPage(e.detail.target);
    dispatch(changePage(page || url, param));
  };

  const slideLoaded = (e) => {
    // console.log(`Page ${e.detail.page} loaded with video`, e.detail.hasVideo);
    const links = e.detail.script.events.reduce((acc, event) => {
      event.hyperlinks.forEach((h) => acc.add(h.url));
      return acc;
    }, new Set());
    const linkedPages = Array.from(links).reduce((acc, link) => {
      const [url, page, params] = extractPage(link);
      let param;
      let modifier;
      const match = params ? params.match(/(\S*)\?(\S*)/) : null;
      if (match) [, param, modifier] = match;
      else param = params;
      acc[page] = page ? { param, modifier } : { url };
      return acc;
    }, {});
    dispatch(pageLoaded(e.detail.page, linkedPages, e.detail.hasVideo));
  };

  const slideEnteringState = (e) => {
    // console.log("Slide entering state", e.detail);
    dispatch(pageState(e.detail.page, e.detail.state));
  };

  if (location !== "web_sense") window.location.assign(location);
  else if (!registered) {
    window.document.addEventListener("navigate", navigate, false);
    window.document.addEventListener("ReactSlideLoaded", slideLoaded, false);
    window.document.addEventListener(
      "SlideEnteringState",
      slideEnteringState,
      false
    );
    setRegistered(true);
  }

  const closeThumbnailPopouts = () => {
    dispatch(toggleThumbnailDrawer(false));
  };

  const pagesToLoad = Object.entries(loadedPages);
  const createPage = (entry) => {
    const [page, src] = entry;
    return src === "" ? (
      <div id={`page_${page}`} key={`page_${page}`} />
    ) : (
      <KeyNotePage
        id={`page_${page}`}
        key={`page_${page}`}
        page={page}
        src={src}
      />
    );
  };

  console.log(
    `rendering pages ${currentPage}`,
    pagesToLoad.map((entry) => entry[1]).filter((e) => e !== "")
  );

  if (isMobile) {
    useEffect(() => {
      toast(
        "Welcome to the Web-Sense! For an interactive experience, use a desktop browser.",
        {
          duration: 6000,
          style: {
            borderRadius: "10px",
            background: "#333",
            color: "#fff",
          },
        }
      );
    }, []);
  }

  return (
    <div className="App">
      <CenterSpinner />

      <MobileView viewClassName="App">
        <Toaster />
        <AdobeFullScreen
          url="/web_sense/web_sense.pdf"
          fileName="The Web Sense"
          id="05369386-481f-4682-a629-3c4ec4680f88"
        />
      </MobileView>

      <BrowserView viewClassName="App">
        <div className="popout-slides-container">
          <HoverDrawerPopout />
          <div
            className="drawer-iframe-container"
            onMouseEnter={closeThumbnailPopouts}
          >
            <Drawer />
            <HoverActivator />
            {pagesToLoad.map(createPage)}
          </div>
        </div>
      </BrowserView>
    </div>
  );
}

export default App;
